// styles.js
// Shared styles for ResetPassword page

import { COLORS } from '../../constants';

export const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: '#f5f5f5',
    position: 'relative',
    overflow: 'hidden',
  },

  backgroundDecoration: {
    position: 'absolute',
    top: '-10%',
    right: '-5%',
    width: '500px',
    height: '500px',
    background: `linear-gradient(135deg, ${COLORS.primary}15, ${COLORS.secondary}10)`,
    borderRadius: '50%',
    filter: 'blur(60px)',
    zIndex: 0,
  },

  card: {
    position: 'relative',
    zIndex: 1,
    backgroundColor: '#ffffff',
    borderRadius: '24px',
    padding: '48px',
    maxWidth: '480px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  },

  header: {
    textAlign: 'center',
    marginBottom: '32px',
  },

  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
  },

  logoIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '20px',
    backgroundColor: COLORS.white,
    border: `3px solid ${COLORS.primary}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 24px rgba(206, 17, 38, 0.15)',
    overflow: 'hidden',
  },

  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  logoText: {
    fontSize: '32px',
    fontWeight: '800',
    color: COLORS.primary,
    letterSpacing: '-1px',
  },

  successIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: '#E8F5E9',
    color: '#22C55E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    fontWeight: 'bold',
    boxShadow: '0 8px 24px rgba(34, 197, 94, 0.2)',
  },

  errorIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: '#FFEBEE',
    color: '#DC2626',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    fontWeight: 'bold',
    boxShadow: '0 8px 24px rgba(220, 38, 38, 0.2)',
  },

  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '12px',
    letterSpacing: '-0.5px',
  },

  subtitle: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    margin: '0',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },

  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  inputLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '4px',
  },

  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },

  inputIcon: {
    position: 'absolute',
    left: '16px',
    pointerEvents: 'none',
    zIndex: 1,
  },

  input: {
    width: '100%',
    padding: '14px 16px 14px 48px',
    fontSize: '15px',
    border: '2px solid #e5e5e5',
    borderRadius: '12px',
    outline: 'none',
    transition: 'all 0.2s ease',
    backgroundColor: '#fafafa',
    fontFamily: 'inherit',
  },

  inputFocused: {
    borderColor: COLORS.primary,
    backgroundColor: '#ffffff',
    boxShadow: `0 0 0 4px ${COLORS.primary}10`,
  },

  inputError: {
    borderColor: '#DC2626',
    backgroundColor: '#FEF2F2',
  },

  eyeButton: {
    position: 'absolute',
    right: '12px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    transition: 'background-color 0.2s ease',
  },

  helperText: {
    fontSize: '13px',
    color: '#888',
    margin: '0',
  },

  errorContainer: {
    backgroundColor: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: '12px',
    padding: '12px 16px',
  },

  errorText: {
    margin: 0,
    fontSize: '14px',
    color: '#DC2626',
    fontWeight: '500',
  },

  submitButton: {
    width: '100%',
    padding: '16px',
    fontSize: '16px',
    fontWeight: '600',
    color: '#ffffff',
    backgroundColor: COLORS.primary,
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 16px rgba(206, 17, 38, 0.2)',
    marginTop: '8px',
  },

  submitButtonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },

  backLinkContainer: {
    textAlign: 'center',
    marginTop: '24px',
  },

  backLink: {
    background: 'none',
    border: 'none',
    color: COLORS.primary,
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    padding: '8px',
  },

  successIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
  },

  successTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '16px',
    textAlign: 'center',
    letterSpacing: '-0.5px',
  },

  successText: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    textAlign: 'center',
    marginBottom: '24px',
  },

  redirectText: {
    fontSize: '14px',
    color: '#888',
    textAlign: 'center',
    marginBottom: '24px',
    fontStyle: 'italic',
  },

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 0',
  },

  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid #f3f3f3',
    borderTop: `4px solid ${COLORS.primary}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};
